import { io } from 'socket.io-client';

class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect(token) {
    if (this.socket?.connected) return;

    // In dev, CRA proxy forwards to localhost:5000
    // In production, derive server URL from REACT_APP_API_URL (strip /api suffix)
    const apiUrl = process.env.REACT_APP_API_URL || '';
    const serverUrl = apiUrl.replace(/\/api$/, '') || undefined;

    this.socket = io(serverUrl, {
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      console.log('WebSocket connected');
    });

    this.socket.on('disconnect', (reason) => {
      console.log('WebSocket disconnected:', reason);
    });

    this.socket.on('connect_error', (err) => {
      console.error('WebSocket connection error:', err.message);
    });

    // Re-attach any listeners that were registered before connect
    this.listeners.forEach((callbacks, event) => {
      callbacks.forEach((cb) => this.socket.on(event, cb));
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);

    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }

    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  emit(event, data) {
    if (this.socket?.connected) {
      this.socket.emit(event, data);
    }
  }

  joinSite(siteId) {
    this.emit('join_site', siteId);
  }

  leaveSite(siteId) {
    this.emit('leave_site', siteId);
  }
}

const websocketService = new WebSocketService();
export default websocketService;
